module.exports = {
    "id": "palm",
    "title": "palm",
    "image": "provision/parts/palm/palm.png",
    "info": [
      {
        "text": "Add a palm leaf to your project.",
        "image": "provision/parts/palm/palm.png"
      }
    ],
    "exposedVariables": []
};